import {ellipsis} from 'polished';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

interface PillStyleProps {
  $hasHover?: boolean;
  shouldRemoveLeftMargin?: boolean;
}

export const StyledPillDiv = styled.div<PillStyleProps>`
  display: inline-block;

  vertical-align: middle;
  max-width: 200px;
  padding: 1px 3px;
  margin-left: ${(p) => (p.shouldRemoveLeftMargin ? 0 : '2px')};

  background: ${(p) => p.theme.greys.shade10};
  background: ${(p) => (p.$hasHover ? p.theme.greys.shade30 : p.theme.greys.shade10)};
  border: 1px solid ${(p) => p.theme.greys.shade60};
  border-radius: 2px;

  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.semibold};
  text-transform: uppercase;

  &:hover {
    background: ${(p) => p.theme.greys.shade30};
  }

  ${ellipsis('200px')};
`;

export const StyledPopoverCoordinatorWrapperDiv = styled.div`
  display: inline-block;
  margin: 0;
`;
